import React from "react";
import { useTranslation } from "react-i18next";
import LoginForm from "../../forms/login/login.form";
import logo from "../../assets/logoPrimary.png";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export default function LoginPage() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div className="h-full w-full flex flex-col items-center justify-center bg-gradient-to-br from-background to-muted/30 p-4 relative pt-20">
      

      <Card className="w-full max-w-md shadow-2xl bg-card/90 backdrop-blur-lg rounded-xl">
        <CardHeader className="text-center items-center">
          <Link to="/" className="mb-4">
            <img 
              src={logo} 
              alt={t('common.logoAlt', 'Al Saqr Logo')} 
              className="w-20 h-auto mx-auto transition-transform hover:scale-105"
            />
          </Link>
          <CardTitle className="text-2xl font-bold tracking-tight text-foreground">
            {t("loginpage.title", "Login to AlSaqr")}
          </CardTitle>
          <CardDescription className="text-muted-foreground">
            {t("loginpage.description", "Enter your credentials to access your account.")}
          </CardDescription>
        </CardHeader>
        <CardContent className="px-6 py-4">
          <LoginForm />
        </CardContent>
        <CardFooter className="flex flex-col items-center justify-center text-xs text-muted-foreground pt-4 pb-6 border-t border-border/50">
          <p>
            {t('loginpage.noAccount', "Don't have an account?")}{' '}
            <Button variant="link" size="sm" className="p-0 h-auto font-semibold text-primary hover:underline">
              {t('loginpage.signUpHere', 'Sign up here')}
            </Button>        
          </p>
          <Button 
        asChild 
        variant="outline" 
        className="{cn(isRTL ? 'mr-2' : 'ml-2')}"
      >
        <Link to="/">
          <ArrowLeft size={16} className={cn(isRTL ? "ml-2" : "mr-2")} />
          {t('common.backToHome', 'Back to Home')}
        </Link>
      </Button>
        </CardFooter>
      </Card>
     
    </div>
  );
}
